@if (loading()) {
    <div class="table-display skeleton">
        <div class="background-icon-skeleton"></div>
        <div class="table-container">
            <table>
                <thead>
                    <tr>
                        @for (column of columns(); track column.key) {
                            <th [style.width]="column.width">
                                <span class="skeleton-text header-skeleton"></span>
                            </th>
                        }
                    </tr>
                </thead>
                <tbody>
                    @for (row of skeletonRows; track row) {
                        <tr>
                            @for (column of columns(); track column.key) {
                                <td [style.width]="column.width">
                                    <span class="skeleton-text cell-skeleton"></span>
                                </td>
                            }
                        </tr>
                    }
                </tbody>
            </table>
        </div>

        <div class="footer">
            <span class="skeleton-text footer-skeleton"></span>
        </div>
    </div>
} @else if (isEmpty()) {
    <div
        class="table-display empty-state-container"
        [style.--state-accent]="stateConfig().accent"
        [style.--state-text]="stateConfig().text"
    >
        <div class="empty-state-content">
            @if (emptyStateIcon()) {
                <div class="background-icon">
                    <i [class]="emptyStateIcon()"></i>
                </div>
            }
            <span class="empty-message">{{ emptyMessageTranslationKey() | translate }}</span>
        </div>
    </div>
} @else {
    <div class="table-display" [style.--state-accent]="stateConfig().accent" [style.--state-text]="stateConfig().text">
        @if (icon()) {
            <div class="background-icon">
                <i [class]="icon()"></i>
            </div>
        }
        <div class="table-container">
            <table>
                <thead>
                    <tr>
                        @for (column of columns(); track column.key) {
                            <th [style.width]="column.width">{{ column.translationKey | translate }}</th>
                        }
                    </tr>
                </thead>
                <tbody>
                    @for (row of displayedRows(); track $index) {
                        <tr>
                            @for (cell of row.cells; track cell.key) {
                                <td [style.width]="cell.width">{{ cell.value }}</td>
                            }
                        </tr>
                    }
                </tbody>
            </table>
        </div>

        <div class="footer">
            <span class="total-count">{{ totalItemsTranslationKey() | translate: { numberOfItems: totalRows() } }}</span>
        </div>
    </div>
}
